import { makeEntityScaffold } from '@classpass/saga-tools';

export const classesByVenue = makeEntityScaffold(
  'SAGA.API.CLASSES_BY_VENUE',
  (client, venueId, params, overrides) => client.venues.getClassesByVenue(venueId, params, overrides),
  { defaultKey: 1 }
);

export const scheduleForClass = makeEntityScaffold(
  'SAGA.API.SCHEDULE_FOR_CLASS',
  (client, classId, options) => client.class.getSchedules(classId, options).then(data => data.schedules),
  { defaultKey: 1 }
);

export const classInfoByVenueAlias = makeEntityScaffold(
  'SAGA.API.CLASS_INFO_BY_VENUE_ALIAS',
  (client, alias, classAlias, overrides) => client.venues.getClassInfoByVenueAlias(alias, classAlias, overrides),
  { defaultKey: 2 }
);

export const reviewsForClass = makeEntityScaffold(
  'SAGA.API.REVIEWS_FOR_CLASS',
  (client, classId, page = 0, pageSize = 25) =>
    client.class.getReviews(classId, {
      page_size: pageSize,
      page: parseInt(page, 10),
      meta: true,
    }),
  { defaultKey: [1, 2] }
);

export const reviewsForClassV2 = makeEntityScaffold(
  'SAGA.API.REVIEWS_FOR_CLASS_V2',
  (client, classId, page = 0, pageSize = 4, limitFeatured = 3) =>
    client.class.getReviewsV2(classId, {
      limit_featured: limitFeatured,
      page_size: pageSize,
      page,
    }),
  { defaultKey: [1, 2] }
);
